function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
export class EntityContext {
    constructor() {
        // Master map: EntityType -> (OriginalText -> Tag)
        this.entityMaps = new Map();
        // Counters for each entity type
        this.counters = new Map();
    }
    getOrCreateTag(type, originalText) {
        // Initialize map for this type if it doesn't exist
        if (!this.entityMaps.has(type)) {
            this.entityMaps.set(type, new Map());
        }
        // Initialize counter for this type if it doesn't exist
        if (!this.counters.has(type)) {
            this.counters.set(type, 0);
        }
        const map = this.entityMaps.get(type);
        if (map.has(originalText)) {
            return map.get(originalText);
        }
        // Increment counter and create new tag
        const currentCount = this.counters.get(type) + 1;
        this.counters.set(type, currentCount);
        const tag = `[${type}_${currentCount}]`;
        map.set(originalText, tag);
        return tag;
    }
    deanonymize(text) {
        let result = text;
        for (const [type, map] of this.entityMaps.entries()) {
            for (const [original, tag] of map.entries()) {
                // Use a global regex to replace all occurrences of the tag
                // We need to escape the tag because it contains square brackets
                const escapedTag = tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedTag, 'g');
                result = result.replace(regex, original);
            }
        }
        return result;
    }
    loadFromSnapshot(snapshot) {
        this.entityMaps.clear();
        this.counters.clear();
        Object.entries(snapshot).forEach(([type, entries]) => {
            const map = new Map();
            let maxCounter = 0;
            const tagPattern = new RegExp(`^\\[${escapeRegExp(type)}_(\\d+)\\]$`);
            Object.entries(entries).forEach(([original, tag]) => {
                map.set(original, tag);
                const match = tagPattern.exec(tag);
                if (match) {
                    const counter = Number(match[1]);
                    if (!Number.isNaN(counter)) {
                        maxCounter = Math.max(maxCounter, counter);
                    }
                }
            });
            if (map.size > 0) {
                this.entityMaps.set(type, map);
                this.counters.set(type, maxCounter);
            }
        });
    }
    getAllMaps() {
        return this.entityMaps;
    }
    clear() {
        this.entityMaps.clear();
        this.counters.clear();
    }
}
